<template>
<v-app>
  <form>
    <v-card>
      <v-card-title>
        <span class="headline" v-if="!business.id">New business</span>
        <v-layout v-if="business.id" column ma-0>
          <span class="headline">Edit "{{ business.name }}"</span>
          <span style="font-size: 16px">{{ business.id }}</span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn text icon @click="clearBusiness">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs color="#EEE" v-model="currentTab" centered show-arrows>
          <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab key="1" href="#tab-1">General</v-tab>
          <v-tab key="2" href="#tab-2">Inteface</v-tab>
          <v-tab key="3" href="#tab-3">Services</v-tab>
          <v-tab key="4" href="#tab-4">API&amp;Contact</v-tab>
          <v-tab key="5" href="#tab-5">French</v-tab>

          <v-tabs-items v-model="currentTab">
            <v-tab-item key="1" value="tab-1">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm9>
                    <v-text-field
                      label="Business Name*"
                      v-model.trim="business.name"
                      v-validate="'required'"
                      :error-messages="errors.collect('business.name')"
                      data-vv-name="business.name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-text-field
                      label="Code*"
                      v-model.trim="business.code"
                      v-validate="'required|alpha_num'"
                      :error-messages="errors.collect('business.code')"
                      data-vv-name="business.code"
                      :disabled="business.id && business.id !== ''"
                      required
                    ></v-text-field>
                    <input type="hidden" name="business.id" v-model.trim="business.id" />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Default business plan*"
                      v-model.trim="business.default_business_plan"
                      v-validate="'required|alpha_dash'"
                      :error-messages="errors.collect('business.default_business_plan')"
                      data-vv-name="business.default_business_plan"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-text-field
                      label="Front Channel ID*"
                      v-model.trim="business.front_channel_id"
                      v-validate="'required|frontChannelId'"
                      :error-messages="errors.collect('Front channel ID')"
                      data-vv-name="Front channel ID"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex x6 sm3>
                    <v-text-field
                      label="Old business ID"
                      v-model.trim="business.old_id"
                      :error-messages="errors.collect('old business ID')"
                      v-validate="'numeric'"
                      data-vv-name="old business ID"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Twilio phone number (e164 format only)*"
                      v-model.trim="business.phone_number"
                      v-validate="'phoneNumber|required'"
                      :error-messages="errors.collect('phone number')"
                      data-vv-name="phone number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex x6 sm6>
                    <v-switch v-model="business.is_active" color="indigo" label="Business active ?"></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="allDomains"
                      v-model="selectedDomain"
                      label="Default business domain"
                      :error-messages="errors.collect('selectedDomain')"
                      data-vv-name="selectedDomain"
                      data-vv-validate-on="blur"
                    ></v-select>
                    <v-list two-line dense v-if="business.domains">
                      <v-list-item v-for="(item,index) in allDomains" :key="index">
                        <v-list-item-content>
                          <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-btn icon @click.stop="removeDomain(item)">
                            <v-icon color="pink">delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <v-list v-else>
                      <v-list-item>No domains configured</v-list-item>
                    </v-list>
                    <v-layout row v-if="showNewDomain">
                      <v-flex xs10>
                        <v-text-field
                          label="New domain to add*"
                          v-model.trim="newDomain"
                          required
                          clearable
                          xs2
                          v-validate="{required: true, regex: /^[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,}$/}"
                          :error-messages="errors.collect('newDomain')"
                          data-vv-name="newDomain"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-btn color="success" small @click.stop="addDomain(newDomain)">Save</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else>
                      <v-flex xs12>
                        <v-btn small @click.stop="showNewDomain = true">Add new domain</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-textarea
                      label="Text message to be sent to users"
                      filled
                      v-model.trim="customMessage"
                      :hint="hint"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="2" value="tab-2">
              <v-container grid-list-md>
                <v-layout row>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Primary color (HEX #XXXXXX)"
                      v-model.trim="business.primary_color"
                      :error-messages="errors.collect('primary color')"
                      v-validate="'hexColor'"
                      data-vv-name="primary color"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Secondary color (HEX #XXXXXX)"
                      v-model.trim="business.secondary_color"
                      :error-messages="errors.collect('secondary color')"
                      v-validate="'hexColor'"
                      data-vv-name="secondary color"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 sm6>
                    <img
                      alt="Thumbnail"
                      :src="(business.logo.public_url) ? business.logo.public_url : business.logo"
                      v-if="business.logo"
                      width="100"
                      height="auto"
                    />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <file-upload
                      :file-name="`logo-${business.code}`"
                      :file-path="`business_images/logos`"
                      v-model="business.logo"
                    ></file-upload>
                  </v-flex>
                </v-layout>
                <v-flex xs12 sm12>
                  <v-text-field
                    label="Business logo URL"
                    :input="(business.logo && business.logo.public_url) ? business.logo.public_url : business.logo"
                    :error-messages="errors.collect('business.logo')"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-layout row>
                  <v-flex xs12 sm6>
                    <img
                      alt="Thumbnail"
                      :src="(business.background.public_url) ? business.background.public_url : business.background"
                      v-if="business.background"
                      width="100"
                      height="auto"
                    />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <file-upload
                      :file-path="`business_images/backgrounds`"
                      v-model="business.background"
                    ></file-upload>
                  </v-flex>
                </v-layout>
                <v-flex xs12 sm12>
                  <v-text-field
                    label="Business background URL*"
                    v-model="business.background"
                    :error-messages="errors.collect('business.background')"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-layout row>
                  <v-flex xs12 sm6>
                    <img
                      alt="Thumbnail"
                      :src="(business.banner && business.banner.public_url) ? business.banner.public_url : business.banner"
                      v-if="business.banner"
                      width="100"
                      height="auto"
                    />
                  </v-flex>
                  <v-flex xs12 sm6>
                    <file-upload :file-path="`business_images/banners`" v-model="business.banner"></file-upload>
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-text-field
                    label="Business banner upload object"
                    :value="(business.banner && business.banner.public_url) ? business.banner.public_url : business.banner"
                    :error-messages="errors.collect('business.banner')"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-container>
            </v-tab-item>
            <v-tab-item key="3" value="tab-3">
              <v-container grid-list-md>
                <v-flex>
                  <vue-json-editor
                    v-model="businessServices"
                    :show-btns="false"
                    :expandedOnStart="false"
                    @json-change="onBusinessServicesJsonChange"
                  ></vue-json-editor>
                </v-flex>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-switch
                      color="indigo"
                      label="White-label product"
                      v-model.trim="business.white_label_product"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-switch
                      color="indigo"
                      label="Laundry rolling"
                      v-model.trim="business.laundry_rolling"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-text-field
                      label="Operating margin"
                      v-model.trim="business.operating_margin"
                      prefix="%"
                      :error-messages="errors.collect('operating margin')"
                      v-validate="'numeric'"
                      data-vv-name="operating margin"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-textarea
                      label="Specificities"
                      filled
                      hint="Any useful info to know about the business"
                      v-model.trim="business.specifities"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <span style="color: rgba(0, 0, 0, 0.54)">Our services</span>
                    <vue-editor v-model.trim="customServices.en" :editorToolbar="customToolbar"></vue-editor>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="4" value="tab-4">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm9>
                    <v-autocomplete
                      v-model="business.api_country_code"
                      label="Api country"
                      :items="countries"
                      item-text="Name"
                      item-value="Code"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                      label="Api country code"
                      v-model.trim="business.api_country_code"
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field label="Api default plan" v-model.trim="business.api_default_plan"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-switch
                      v-model="business.api_is_metered"
                      color="indigo"
                      label="Is api metered ?"
                    ></v-switch>
                  </v-flex>
                  <v-layout row v-if="business.api_is_metered">
                    <v-flex xs12 sm6>
                      <v-text-field
                        label="Metered subscription ID"
                        v-model.trim="business.api_subscription_id"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 order-sm6>
                      <v-text-field
                        label="Metered subscription Item ID (usage)"
                        v-model.trim="business.api_subscription_item_id"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12 sm7>
                    <v-text-field label="Contact ID" v-model.trim="contactInfo"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field label="Contact name" disabled v-model.trim="contact.name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field label="Contact email" disabled v-model.trim="contact.email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                      label="Contact phone number"
                      disabled
                      v-model.trim="contact.phone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field
                      v-if="differentInvoiceCustomer"
                      label="Invoice customer ID"
                      v-model.trim="business.invoice_customer_id"
                      :error-messages="errors.collect('invoice customer ID')"
                      v-validate="'customerId'"
                      data-vv-name="invoice customer ID"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      disabled
                      label="Invoice customer ID"
                      v-model.trim="contact.customer"
                      :error-messages="errors.collect('invoice customer ID')"
                      v-validate="'customerId'"
                      data-vv-name="invoice customer ID"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-switch
                      v-model="differentInvoiceCustomer"
                      color="indigo"
                      label="Different invoice customer ID ?"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="5" value="tab-5">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <span
                      style="font-size: 18px"
                      class="grey--text"
                    >Only used when the Business is not French by default.</span>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-textarea
                      label="Text message to be sent to French users"
                      filled
                      v-model.trim="customMessageFr"
                      :hint="hint"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <span style="color: rgba(0, 0, 0, 0.54)">Our services in French</span>
                    <vue-editor v-model.trim="customServices.fr" :editorToolbar="customToolbar"></vue-editor>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <small>*indicates required field</small>
        <v-spacer></v-spacer>
        <v-btn text @click="clearBusiness">Close</v-btn>
        <v-btn color="success" outlined @click="saveBusiness">Save</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</v-app>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapMutations } from "vuex";
import FileUploadComponent from "@/components/FileUpload";
import { Validator } from "vee-validate";
import PhoneNumber from "awesome-phonenumber";
import { VueEditor } from "vue2-editor";
import vueJsonEditor from "vue-json-editor";

const phoneNumber = {
  getMessage: field => `${field} is not a valid phone number`,
  validate(value) {
    return new Promise(resolve => {
      let regex = new RegExp(/^\+\d*$/);
      let res = regex.test(value);
      let phone = new PhoneNumber(value);
      resolve({ valid: phone.isValid() && res });
    });
  }
};

const regexTest = {
  customerId: {
    getMessage: field => `${field} should be a Stripe customer ID`,
    validate(value) {
      return new Promise(resolve => {
        let regex = new RegExp(/^cus_\w{14}$/);
        let res = regex.test(value);
        resolve({ valid: res });
      });
    }
  },
  frontChannelId: {
    getMessage: field => `The ${field} field should be a Front channel ID`,
    validate(value) {
      return new Promise(resolve => {
        let regex = new RegExp(/^cha_\w{3,4}$/);
        let res = regex.test(value);
        resolve({ valid: res });
      });
    }
  },
  hexColor: {
    getMessage: field => `${field} should be a HEX color`,
    validate(value) {
      return new Promise(resolve => {
        let regex = new RegExp(/^#\w{6}$/);
        let res = regex.test(value);
        resolve({ valid: res });
      });
    }
  }
};

Validator.extend("phoneNumber", phoneNumber);
Validator.extend("customerId", regexTest.customerId);
Validator.extend("frontChannelId", regexTest.frontChannelId);
Validator.extend("hexColor", regexTest.hexColor);

const businesses = fb.db.collection("business_profiles");
const users = fb.db.collection("user_profiles");

export default {
  name: "BusinessFormComponent",
  components: {
    fileUpload: FileUploadComponent,
    VueEditor,
    vueJsonEditor
  },
  props: {
    business: Object
  },
  data: () => ({
    showNewDomain: false,
    newDomain: "",
    logoUrl: "",
    selectedDomain: "",
    currentTab: "tab-1",
    differentInvoiceCustomer: false,
    allDomains: [],
    contact: {
      id: "",
      name: "",
      email: "",
      phone: "",
      customer: "",
      valid: true
    },
    defaultMessageText:
      "Bienvenue chez {{name}}, vous pouvez nous envoyer toutes vos demandes au {{phone}} 7j/7.",
    customMessageText: "",
    customMessageTextFr: "",
    hint:
      "Use {{name}} and {{phone}} as replacement of the business name and phone number.",
    customToolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["code-block"]
    ],
    defaultBusinessServices: {
      en: [
        {
          category: "daily",
          name: "Daily",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Pressing",
              description:
                "Tarifs des différents services de pressing.<br>Repassage entièrement à la main.",
              items: [
                {
                  name: "Chemise sur cintre",
                  price: "2,60€"
                },
                {
                  name: "Chemise pliée",
                  price: "3,80€"
                },
                {
                  name: "Chemise spéciale",
                  price: "8,00€"
                },
                {
                  name: "Chemisier",
                  price: "6,40€"
                },
                {
                  name: "Costume",
                  price: "12,50€"
                },
                {
                  name: "Costume délicat",
                  price: "20,00€"
                },
                {
                  name: "Costume 3 pièces",
                  price: "24,00€"
                },
                {
                  name: "Pantalon",
                  price: "6,00€"
                },
                {
                  name: "Pantalon délicat",
                  price: "8,00€"
                },
                {
                  name: "Veste",
                  price: "6,50€"
                },
                {
                  name: "Robe/Combinaison",
                  price: "9,50€"
                },
                {
                  name: "Manteau/Trench",
                  price: "11,50€"
                },
                {
                  name: "Jupe",
                  price: "5,70€"
                },
                {
                  name: "Jupe longue",
                  price: "12,00€"
                },
                {
                  name: "Jupe spéciale",
                  price: "13,00€"
                },
                {
                  name: "T-shirt/Polo",
                  price: "5,00€"
                },
                {
                  name: "Pull",
                  price: "6,00€"
                },
                {
                  name: "Pull spécial",
                  price: "8,00€"
                },
                {
                  name: "Robe délicate",
                  price: "13,00€"
                },
                {
                  name: "Short",
                  price: "5,20€"
                },
                {
                  name: "Veste spéciale",
                  price: "8,50€"
                },
                {
                  name: "Cravate/Noed papillon",
                  price: "5,50€"
                },
                {
                  name: "Echarpe/foulard",
                  price: "6,00€"
                },
                {
                  name: "Blouson/ Parka",
                  price: "11,50€"
                },
                {
                  name: "Doudoune simple",
                  price: "13,00€"
                },
                {
                  name: "Doudoune molletonnée",
                  price: "21,00€"
                },
                {
                  name: "Couverture",
                  price: "17,00€"
                },
                {
                  name: "Imperméable",
                  price: "17,00€"
                },
                {
                  name: "Couette plume",
                  price: "25,50€"
                },
                {
                  name: "Couette synthétique/Simple",
                  price: "19,00€"
                },
                {
                  name: "Duvet/Sac de couchage",
                  price: "19,00€"
                },
                {
                  name: "Rideau",
                  price: "14,30€"
                },
                {
                  name: "Tapis",
                  price: "14,30€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Cordonnerie",
              description: "Tarifs des différents services de cordonnerie.",
              items: [
                {
                  name: "Patins de protection femme",
                  price: "13,60€"
                },
                {
                  name: "Patins de protection homme",
                  price: "16,00€"
                },
                {
                  name: "Patins de protection naturel femme",
                  price: "16,00€"
                },
                {
                  name: "Patins de protection naturel femme",
                  price: "20,00€"
                },
                {
                  name: "Talons à tige caoutchouc",
                  price: "9,60€"
                },
                {
                  name: "Talons ville femme",
                  price: "13,60€"
                },
                {
                  name: "Talons ville homme",
                  price: "16,00€"
                },
                {
                  name: "Changement des blocs talons",
                  price: "48,00€"
                },
                {
                  name: "Redresse (unité)",
                  price: "3,20€"
                },
                {
                  name: "Fers (à l'avant)",
                  price: "6,40€"
                },
                {
                  name: "Fers encastrés vis laiton",
                  price: "15,20€"
                },
                {
                  name: "Bouts à l'avant femme (cuir/caoutchouc)",
                  price: "8,00€"
                },
                {
                  name: "Bouts à l'avant homme (cuir/caoutchouc)",
                  price: "9,60€"
                },
                {
                  name: "Fermeture à glissière (unité)",
                  price: "25,60€"
                },
                {
                  name: "Fermeture à glissière pour bottes(unité)",
                  price: "32,00€"
                },
                {
                  name: "Boucle posée",
                  price: "8,80€"
                },
                {
                  name: "Forçage chaussures",
                  price: "8,80€"
                },
                {
                  name: "Nettoyage cuir",
                  price: "28,00€"
                },
                {
                  name: "Cirage",
                  price: "8,00€"
                },
                {
                  name: "Glaçage",
                  price: "20,00€"
                },
                {
                  name: "Rassemelage complet femme",
                  price: "92,00€"
                },
                {
                  name: "Rassemelage complet homme",
                  price: "116,00€"
                },
                {
                  name: "Demi-semelles femme caoutchouc",
                  price: "26,40€"
                },
                {
                  name: "Demi-semelles",
                  price: "29,60€"
                },
                {
                  name:
                    "Demi-semelles + coutures semelles homme cuir + liège, Blake ou petits points",
                  price: "76,00€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Retouches",
              description: "Tarifs des différents services de retouches.",
              items: [
                {
                  name: "Pose boutons",
                  price: "3,00€"
                },
                {
                  name: "Petite retouche",
                  price: "3,50€"
                },
                {
                  name: "Retouche spéciale",
                  price: "12,00€"
                },
                {
                  name: "Pantalon - Ourlet",
                  price: "7,00€"
                },
                {
                  name: "Pantalon - Usure légère",
                  price: "9,00€"
                },
                {
                  name: "Pantalon - Usure importante (pose d'une pièce)",
                  price: "12,00€"
                },
                {
                  name: "Pantalon - Poches déchirées",
                  price: "25,00€"
                },
                {
                  name: "Pantalon - Changer fermeture éclair",
                  price: "7,00€"
                }
              ]
            }
          ]
        },
        {
          category: "home",
          name: "Domicile",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Ménage",
              description:
                "Tarifs des différents services de ménage.<br>Tarifs horaires.",
              items: [
                {
                  name: "Ménage/Repassage",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Repassage",
              description:
                "Tarifs des différents services de repassage.<br>Tarifs horaires.",
              items: [
                {
                  name: "Ménage/Repassage",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Bricolage",
              description: "Tarifs des différents services de bricolage.",
              items: [
                {
                  name: "Petit bricolage",
                  price: "à partir de 30€"
                },
                {
                  name: "Plombier",
                  price: "à partir de 45€"
                },
                {
                  name: "Serrurier",
                  price: "à partir de 45€"
                },
                {
                  name: "Chauffagiste",
                  price: "à partir de 45€"
                },
                {
                  name: "Electricien",
                  price: "à partir de 45€"
                },
                {
                  name: "Jardinage",
                  price: "à partir de 25€"
                },
                {
                  name: "Déménagement",
                  price: "à partir de 49€"
                }
              ]
            }
          ]
        },
        {
          category: "family",
          name: "Ma famille",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Garde d'enfants",
              description:
                "Tarifs des différents services de garde d'enfants.<br>Tarifs horaires.",
              items: [
                {
                  name: "garde d'enfants",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Aide scolaire",
              description:
                "Tarifs des différents services d'aide scolaire'.<br>Tarifs horaires.",
              items: [
                {
                  name: "Aide scolaire",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Gestion administrative",
              description:
                "Tarifs des différents services de gestion administrative.<br>Gratuit 1 heure par mois.",
              items: [
                {
                  name: "Gestion administrative",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Aide aux personnes âgées",
              description:
                "Tarifs des différents services d'aide aux personnes âgées'.<br>Tarifs horaires.",
              items: [
                {
                  name: "Aide aux personnes âgées",
                  price: "à partir de 25€"
                }
              ]
            }
          ]
        },
        {
          category: "leisure",
          name: "Loisirs",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Location de voitures",
              description:
                "Tarifs des différents services de location de voiture.",
              items: [
                {
                  name: "Location de voiture",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Organisation de voyage",
              description:
                "Tarifs des différents services d'organisation de voyage.",
              items: [
                {
                  name: "Organisation de voyage",
                  price: "en fonction de la demande"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Lavage véhicule",
              description:
                "Tarifs des différents services de lavage de véhicule.",
              items: [
                {
                  name: "Lavage véhicule",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Réparation informatique",
              description:
                "Tarifs des différents services de réparation informatique.",
              items: [
                {
                  name: "Réparation informatique",
                  price: "à partir de 39,99€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Garde d'animaux",
              description: "Tarifs des différents services de garde d'animaux.",
              items: [
                {
                  name: "Garde et promenade d'animaux",
                  price: "à partir de 10€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Billeterie",
              description: "Tarifs des différents services de billeterie.",
              items: [
                {
                  name: "Frais de services",
                  price: "offert"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Réservation",
              description: "Tarifs des différents services de réservations.",
              items: [
                {
                  name: "Réservation",
                  price: "gratuit"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Prise de RDV",
              description:
                "Tarifs des différents services de prise de rendez-vous.",
              items: [
                {
                  name: "Prise de RDV",
                  price: "gratuit"
                },
                {
                  name: "Mise en relation",
                  price: "gratuit"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Recherches",
              description: "Tarifs des différents services de recherches.",
              items: [
                {
                  name: "Recherches",
                  price: "gratuit"
                }
              ]
            }
          ]
        },
        {
          category: "welness",
          name: "Bien être",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Coach sportif à domicile",
              description:
                "Tarifs des différents services de coach sportif à domicile.",
              items: [
                {
                  name: "Coach sportif individuel",
                  price: "à partir de 49€"
                },
                {
                  name: "Coach sportif pour 5 personnes",
                  price: "à partir de 12,30€ par personne"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Massage",
              description:
                "Tarifs des différents services de massage à domicile.",
              items: [
                {
                  name: "Massage à comicile (60mn)",
                  price: "à partir de 59€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Coiffure",
              description:
                "Tarifs des différents services de coiffures à domicile/entreprise.",
              items: [
                {
                  name: "Coiffure à domicile homme",
                  price: "à partir de 30€"
                },
                {
                  name: "Coiffure à domicile femme",
                  price: "à partir de 40€"
                },
                {
                  name: "Atelier coiffure en entreprise homme",
                  price: "à partir de 20€"
                },
                {
                  name: "Atelier coiffure en entreprise femme",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Manucure à domicile",
              description:
                "Tarifs des différents services de manucure à domicile.<br> Tarifs minimum.",
              items: [
                {
                  name: "Manucure à domicile",
                  price: "à partir de 29,90€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Cours de cuisine",
              description:
                "Tarifs des différents services cours de cuisines.<br>Tarifs horaires minimum.",
              items: [
                {
                  name: "Cours de cuisine",
                  price: "à partir de 30€"
                }
              ]
            }
          ]
        },
        {
          category: "delivery",
          name: "Livraisons",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Fleurs",
              description:
                "Tarifs des différents services de livraison de fleurs.",
              items: [
                {
                  name: "Livraison de fleurs",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Coursier",
              description:
                "Tarifs des différents services de coursiers.<br>Tarifs minimum.",
              items: [
                {
                  name: "Coursier",
                  price: "12€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Pharmacie",
              description:
                "Tarifs des différents services de livraisons de pharmacie.",
              items: [
                {
                  name: "Livraison de pharmacie",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Personal shopper",
              description:
                "Tarifs des différents services de personal shopper.",
              items: [
                {
                  name: "Personal shopper<br>(au dessus de 100€ d'achats)",
                  price: "sur devis, pas de commission"
                },
                {
                  name: "Personal shopper<br>(en dessous de 100€ d'achats)",
                  price: "sur devis, 5% de commission"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Nourriture",
              description:
                "Tarifs des différents services de livraisons de nourriture.",
              items: [
                {
                  name: "Livraison de nourriture",
                  price: "commande + tarif de livraison"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Colis",
              description:
                "Tarifs des différents services de livraisons de colis.",
              items: [
                {
                  name: "Livraison de colis",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Objets volumineux",
              description:
                "Tarifs des différents services de livraisons d'objets volumineux.",
              items: [
                {
                  name: "Livraison d'objets volumineux",
                  price: "sur devis"
                }
              ]
            }
          ]
        }
      ],
      fr: [
        {
          category: "daily",
          name: "Quotidien",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Pressing",
              description:
                "Tarifs des différents services de pressing.<br>Repassage entièrement à la main.",
              items: [
                {
                  name: "Chemise sur cintre",
                  price: "2,60€"
                },
                {
                  name: "Chemise pliée",
                  price: "3,80€"
                },
                {
                  name: "Chemise spéciale",
                  price: "8,00€"
                },
                {
                  name: "Chemisier",
                  price: "6,40€"
                },
                {
                  name: "Costume",
                  price: "12,50€"
                },
                {
                  name: "Costume délicat",
                  price: "20,00€"
                },
                {
                  name: "Costume 3 pièces",
                  price: "24,00€"
                },
                {
                  name: "Pantalon",
                  price: "6,00€"
                },
                {
                  name: "Pantalon délicat",
                  price: "8,00€"
                },
                {
                  name: "Veste",
                  price: "6,50€"
                },
                {
                  name: "Robe/Combinaison",
                  price: "9,50€"
                },
                {
                  name: "Manteau/Trench",
                  price: "11,50€"
                },
                {
                  name: "Jupe",
                  price: "5,70€"
                },
                {
                  name: "Jupe longue",
                  price: "12,00€"
                },
                {
                  name: "Jupe spéciale",
                  price: "13,00€"
                },
                {
                  name: "T-shirt/Polo",
                  price: "5,00€"
                },
                {
                  name: "Pull",
                  price: "6,00€"
                },
                {
                  name: "Pull spécial",
                  price: "8,00€"
                },
                {
                  name: "Robe délicate",
                  price: "13,00€"
                },
                {
                  name: "Short",
                  price: "5,20€"
                },
                {
                  name: "Veste spéciale",
                  price: "8,50€"
                },
                {
                  name: "Cravate/Noed papillon",
                  price: "5,50€"
                },
                {
                  name: "Echarpe/foulard",
                  price: "6,00€"
                },
                {
                  name: "Blouson/ Parka",
                  price: "11,50€"
                },
                {
                  name: "Doudoune simple",
                  price: "13,00€"
                },
                {
                  name: "Doudoune molletonnée",
                  price: "21,00€"
                },
                {
                  name: "Couverture",
                  price: "17,00€"
                },
                {
                  name: "Imperméable",
                  price: "17,00€"
                },
                {
                  name: "Couette plume",
                  price: "25,50€"
                },
                {
                  name: "Couette synthétique/Simple",
                  price: "19,00€"
                },
                {
                  name: "Duvet/Sac de couchage",
                  price: "19,00€"
                },
                {
                  name: "Rideau",
                  price: "14,30€"
                },
                {
                  name: "Tapis",
                  price: "14,30€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Cordonnerie",
              description: "Tarifs des différents services de cordonnerie.",
              items: [
                {
                  name: "Patins de protection femme",
                  price: "13,60€"
                },
                {
                  name: "Patins de protection homme",
                  price: "16,00€"
                },
                {
                  name: "Patins de protection naturel femme",
                  price: "16,00€"
                },
                {
                  name: "Patins de protection naturel femme",
                  price: "20,00€"
                },
                {
                  name: "Talons à tige caoutchouc",
                  price: "9,60€"
                },
                {
                  name: "Talons ville femme",
                  price: "13,60€"
                },
                {
                  name: "Talons ville homme",
                  price: "16,00€"
                },
                {
                  name: "Changement des blocs talons",
                  price: "48,00€"
                },
                {
                  name: "Redresse (unité)",
                  price: "3,20€"
                },
                {
                  name: "Fers (à l'avant)",
                  price: "6,40€"
                },
                {
                  name: "Fers encastrés vis laiton",
                  price: "15,20€"
                },
                {
                  name: "Bouts à l'avant femme (cuir/caoutchouc)",
                  price: "8,00€"
                },
                {
                  name: "Bouts à l'avant homme (cuir/caoutchouc)",
                  price: "9,60€"
                },
                {
                  name: "Fermeture à glissière (unité)",
                  price: "25,60€"
                },
                {
                  name: "Fermeture à glissière pour bottes(unité)",
                  price: "32,00€"
                },
                {
                  name: "Boucle posée",
                  price: "8,80€"
                },
                {
                  name: "Forçage chaussures",
                  price: "8,80€"
                },
                {
                  name: "Nettoyage cuir",
                  price: "28,00€"
                },
                {
                  name: "Cirage",
                  price: "8,00€"
                },
                {
                  name: "Glaçage",
                  price: "20,00€"
                },
                {
                  name: "Rassemelage complet femme",
                  price: "92,00€"
                },
                {
                  name: "Rassemelage complet homme",
                  price: "116,00€"
                },
                {
                  name: "Demi-semelles femme caoutchouc",
                  price: "26,40€"
                },
                {
                  name: "Demi-semelles",
                  price: "29,60€"
                },
                {
                  name:
                    "Demi-semelles + coutures semelles homme cuir + liège, Blake ou petits points",
                  price: "76,00€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/quotidien.png",
              name: "Retouches",
              description: "Tarifs des différents services de retouches.",
              items: [
                {
                  name: "Pose boutons",
                  price: "3,00€"
                },
                {
                  name: "Petite retouche",
                  price: "3,50€"
                },
                {
                  name: "Retouche spéciale",
                  price: "12,00€"
                },
                {
                  name: "Pantalon - Ourlet",
                  price: "7,00€"
                },
                {
                  name: "Pantalon - Usure légère",
                  price: "9,00€"
                },
                {
                  name: "Pantalon - Usure importante (pose d'une pièce)",
                  price: "12,00€"
                },
                {
                  name: "Pantalon - Poches déchirées",
                  price: "25,00€"
                },
                {
                  name: "Pantalon - Changer fermeture éclair",
                  price: "7,00€"
                }
              ]
            }
          ]
        },
        {
          category: "home",
          name: "Domicile",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Ménage",
              description:
                "Tarifs des différents services de ménage.<br>Tarifs horaires.",
              items: [
                {
                  name: "Ménage/Repassage",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Repassage",
              description:
                "Tarifs des différents services de repassage.<br>Tarifs horaires.",
              items: [
                {
                  name: "Ménage/Repassage",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Bricolage",
              description: "Tarifs des différents services de bricolage.",
              items: [
                {
                  name: "Petit bricolage",
                  price: "à partir de 30€"
                },
                {
                  name: "Plombier",
                  price: "à partir de 45€"
                },
                {
                  name: "Serrurier",
                  price: "à partir de 45€"
                },
                {
                  name: "Chauffagiste",
                  price: "à partir de 45€"
                },
                {
                  name: "Electricien",
                  price: "à partir de 45€"
                },
                {
                  name: "Jardinage",
                  price: "à partir de 25€"
                },
                {
                  name: "Déménagement",
                  price: "à partir de 49€"
                }
              ]
            }
          ]
        },
        {
          category: "family",
          name: "Ma famille",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Garde d'enfants",
              description:
                "Tarifs des différents services de garde d'enfants.<br>Tarifs horaires.",
              items: [
                {
                  name: "garde d'enfants",
                  price: "à partir de 16€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Aide scolaire",
              description:
                "Tarifs des différents services d'aide scolaire'.<br>Tarifs horaires.",
              items: [
                {
                  name: "Aide scolaire",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Gestion administrative",
              description:
                "Tarifs des différents services de gestion administrative.<br>Gratuit 1 heure par mois.",
              items: [
                {
                  name: "Gestion administrative",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/domicilefamille.png",
              name: "Aide aux personnes âgées",
              description:
                "Tarifs des différents services d'aide aux personnes âgées'.<br>Tarifs horaires.",
              items: [
                {
                  name: "Aide aux personnes âgées",
                  price: "à partir de 25€"
                }
              ]
            }
          ]
        },
        {
          category: "leisure",
          name: "Loisirs",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Location de voitures",
              description:
                "Tarifs des différents services de location de voiture.",
              items: [
                {
                  name: "Location de voiture",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Organisation de voyage",
              description:
                "Tarifs des différents services d'organisation de voyage.",
              items: [
                {
                  name: "Organisation de voyage",
                  price: "en fonction de la demande"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Lavage véhicule",
              description:
                "Tarifs des différents services de lavage de véhicule.",
              items: [
                {
                  name: "Lavage véhicule",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Réparation informatique",
              description:
                "Tarifs des différents services de réparation informatique.",
              items: [
                {
                  name: "Réparation informatique",
                  price: "à partir de 39,99€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Garde d'animaux",
              description: "Tarifs des différents services de garde d'animaux.",
              items: [
                {
                  name: "Garde et promenade d'animaux",
                  price: "à partir de 10€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Billeterie",
              description: "Tarifs des différents services de billeterie.",
              items: [
                {
                  name: "Frais de services",
                  price: "offert"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Réservation",
              description: "Tarifs des différents services de réservations.",
              items: [
                {
                  name: "Réservation",
                  price: "gratuit"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Prise de RDV",
              description:
                "Tarifs des différents services de prise de rendez-vous.",
              items: [
                {
                  name: "Prise de RDV",
                  price: "gratuit"
                },
                {
                  name: "Mise en relation",
                  price: "gratuit"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/loisirs.png",
              name: "Recherches",
              description: "Tarifs des différents services de recherches.",
              items: [
                {
                  name: "Recherches",
                  price: "gratuit"
                }
              ]
            }
          ]
        },
        {
          category: "welness",
          name: "Bien être",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Coach sportif à domicile",
              description:
                "Tarifs des différents services de coach sportif à domicile.",
              items: [
                {
                  name: "Coach sportif individuel",
                  price: "à partir de 49€"
                },
                {
                  name: "Coach sportif pour 5 personnes",
                  price: "à partir de 12,30€ par personne"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Massage",
              description:
                "Tarifs des différents services de massage à domicile.",
              items: [
                {
                  name: "Massage à comicile (60mn)",
                  price: "à partir de 59€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Coiffure",
              description:
                "Tarifs des différents services de coiffures à domicile/entreprise.",
              items: [
                {
                  name: "Coiffure à domicile homme",
                  price: "à partir de 30€"
                },
                {
                  name: "Coiffure à domicile femme",
                  price: "à partir de 40€"
                },
                {
                  name: "Atelier coiffure en entreprise homme",
                  price: "à partir de 20€"
                },
                {
                  name: "Atelier coiffure en entreprise femme",
                  price: "à partir de 25€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Manucure à domicile",
              description:
                "Tarifs des différents services de manucure à domicile.<br> Tarifs minimum.",
              items: [
                {
                  name: "Manucure à domicile",
                  price: "à partir de 29,90€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/bien-etre.png",
              name: "Cours de cuisine",
              description:
                "Tarifs des différents services cours de cuisines.<br>Tarifs horaires minimum.",
              items: [
                {
                  name: "Cours de cuisine",
                  price: "à partir de 30€"
                }
              ]
            }
          ]
        },
        {
          category: "delivery",
          name: "Livraisons",
          elements: [
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Fleurs",
              description:
                "Tarifs des différents services de livraison de fleurs.",
              items: [
                {
                  name: "Livraison de fleurs",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Coursier",
              description:
                "Tarifs des différents services de coursiers.<br>Tarifs minimum.",
              items: [
                {
                  name: "Coursier",
                  price: "12€"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Pharmacie",
              description:
                "Tarifs des différents services de livraisons de pharmacie.",
              items: [
                {
                  name: "Livraison de pharmacie",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Personal shopper",
              description:
                "Tarifs des différents services de personal shopper.",
              items: [
                {
                  name: "Personal shopper<br>(au dessus de 100€ d'achats)",
                  price: "sur devis, pas de commission"
                },
                {
                  name: "Personal shopper<br>(en dessous de 100€ d'achats)",
                  price: "sur devis, 5% de commission"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Nourriture",
              description:
                "Tarifs des différents services de livraisons de nourriture.",
              items: [
                {
                  name: "Livraison de nourriture",
                  price: "commande + tarif de livraison"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Colis",
              description:
                "Tarifs des différents services de livraisons de colis.",
              items: [
                {
                  name: "Livraison de colis",
                  price: "sur devis"
                }
              ]
            },
            {
              image:
                "https://media.clac.io/corp/resources/images/services/livraison.png",
              name: "Objets volumineux",
              description:
                "Tarifs des différents services de livraisons d'objets volumineux.",
              items: [
                {
                  name: "Livraison d'objets volumineux",
                  price: "sur devis"
                }
              ]
            }
          ]
        }
      ]
    },
    customServices: {
      en: "",
      fr: ""
    }
  }),
  computed: {
    ...mapState({
      countries: "countries",
      businessList: "businesses"
    }),
    businessServices: {
      get: function() {
        return this.business.services
          ? JSON.parse(this.business.services)
          : this.defaultBusinessServices;
      },
      set: function() {
        return JSON.stringify(this.business.services);
      }
    },
    validatedPhoneNumber: function() {
      if (this.business.phone_number) {
        let phone = new PhoneNumber(this.business.phone_number, "FR");
        return phone.toJSON();
      } else {
        return {};
      }
    },
    contactInfo: {
      get: function() {
        if (this.business.id && this.business.contact_id) {
          return this.business.contact_id;
        } else {
          return "";
        }
      },
      set: function(newValue) {
        if (newValue !== "") {
          users
            .doc(newValue)
            .get()
            .then(doc => {
              if (doc.exists) {
                this.contact.id = newValue;
                this.contact.name = doc.data().display_name;
                this.contact.email = doc.data().email;
                this.contact.phone = doc.data().phone_number;
                this.contact.customer = doc.data().customer_id;
                this.contact.valid = true;
              } else {
                this.contact.name = "";
                this.contact.email = "";
                this.contact.phone = "";
                this.contact.customer = "";
                this.contact.valid = false;
              }
            });
        } else {
          this.contact.id = "";
          this.contact.name = "";
          this.contact.email = "";
          this.contact.phone = "";
          this.contact.customer = "";
          this.contact.valid = true;
        }
      }
    },
    customMessage: {
      get: function() {
        if (this.business.id && this.business.default_phone_message) {
          return this.business.default_phone_message;
        } else {
          return this.defaultMessageText;
        }
      },
      set: function(newValue) {
        this.customMessageText = newValue;
      }
    },
    customMessageFr: {
      get: function() {
        if (this.business.id && this.business.default_phone_message_fr) {
          return this.business.default_phone_message_fr;
        } else {
          return this.defaultMessageTextFr;
        }
      },
      set: function(newValue) {
        this.customMessageTextFr = newValue;
      }
    }
  },
  watch: {
    business: {
      handler: function(val) {
        if (!val || !val.code) {
          let now = Date.now();
          now = now * Math.floor(Math.random() * 1000);
          this.business.code = now.toString(36).toUpperCase();
        }
        if (val.defaultDomain) {
          this.selectedDomain = val.defaultDomain;
        } else {
          this.selectedDomain = null;
        }
        if (val.domains) {
          this.allDomains = val.domains;
        } else {
          this.allDomains = [];
        }
        if (!val.api_country_code) {
          this.business.api_country_code = "FR";
        }
        if (!val.api_default_plan) {
          this.business.api_default_plan = null;
        }
        if (val.custom_services) {
          this.customServices = val.custom_services;
        } else {
          this.customServices = {
            en: "",
            fr: ""
          };
        }
      },
      immediate: true
    },
    logoUrl: {
      handler: function(val) {
        this.business.logo = val;
      },
      deep: true
    },
    contactInfo: {
      handler: function(val) {
        if (val !== "") {
          users
            .doc(val)
            .get()
            .then(doc => {
              if (doc.exists) {
                this.contact.id = doc.id;
                this.contact.name = doc.data().display_name;
                this.contact.email = doc.data().email;
                this.contact.phone = doc.data().phone_number;
                this.contact.customer = doc.data().customer_id;
                this.contact.valid = true;
              } else {
                this.contact.name = "";
                this.contact.email = "";
                this.contact.phone = "";
                this.contact.customer = "";
                this.contact.valid = false;
              }
            });
        } else {
          this.contact.id = "";
          this.contact.name = "";
          this.contact.email = "";
          this.contact.phone = "";
          this.contact.customer = "";
          this.contact.valid = true;
        }
      }
    }
  },
  mounted: function() {
    const contactId = this.business.contact_id;
    if (contactId) {
      this.contact.id = contactId;
      users
        .doc(contactId)
        .get()
        .then(doc => {
          this.contact.name = doc.data().display_name;
          this.contact.email = doc.data().email;
          this.contact.phone = doc.data().phone_number;
          this.contact.customer = doc.data().customer_id;
          if (
            (!this.business.invoice_customer_id ||
              this.business.invoice_customer_id === "") &&
            doc.data().customer_id
          ) {
            this.business.invoice_customer_id = doc.data().customer_id;
          }
          if (this.contact.customer !== this.business.invoice_customer_id) {
            this.differentInvoiceCustomer = true;
          }
        });
    }
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    hideModal() {
      //this.offer.name = "";
      //this.offer.frontChannelId = "";
      this.$emit("close");
    },
    onBusinessServicesJsonChange: function(json) {
      this.business.services = JSON.stringify(json);
    },
    updateLogo: function(url) {
      this.logoUrl = url;
    },
    removeDomain: function(domain) {
      if (domain) {
        this.allDomains.pop(domain);
        if (this.allDomains.length === 0 || this.selectedDomain === domain) {
          this.selectedDomain = "";
        }
      }
    },
    addDomain: function(domain) {
      if (domain) {
        if (!this.$validator.errors.has("newDomain")) {
          if (this.allDomains.indexOf(domain) > -1) {
            this.$validator.errors.add({
              field: "newDomain",
              msg: "This domain name is duplicated"
            });
            return;
          }
          if (this.allDomains.length === 0) {
            this.selectedDomain = domain;
          }

          this.allDomains.push(domain);

          this.showNewDomain = false;
          this.newDomain = "";
        }
      } else {
        this.showNewDomain = false;
      }
    },
    saveBusiness: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.business.created = this.business.created
            ? this.business.created
            : Date.now();
          this.business.domains = this.allDomains;
          this.business.default_domain = this.selectedDomain;
          let country_code = this.business.api_country_code;
          let country = this.countries.find(function(element) {
            return element.Code === country_code;
          });
          this.business.api_country = country.Name;
          this.business.custom_services = this.customServices;
          this.business.services = JSON.stringify(this.businessServices);
          if (this.customMessageText !== "") {
            this.business.default_phone_message = this.customMessageText;
          } else {
            this.business.default_phone_message = this.defaultMessageText;
          }
          if (this.customMessageTextFr !== "") {
            this.business.default_phone_message_fr = this.customMessageTextFr;
          } else {
            this.business.default_phone_message_fr = this.defaultMessageText;
          }
          if (!this.contact.valid) {
            this.setAppAlert({
              visible: true,
              text: "The contact ID is not valid.",
              color: "error"
            });
          } else {
            if (!this.differentInvoiceCustomer) {
              this.business.invoice_customer_id = this.contact.customer;
            }
            this.business.contact_id = this.contact.id;
            if (this.validatedPhoneNumber.valid) {
              this.business.phone_number = this.validatedPhoneNumber.number.e164;
              this.business.phone_number_national = this.validatedPhoneNumber.number.national.replace(
                / /g,
                ""
              );
              this.business.phone_number_region = this.validatedPhoneNumber.regionCode;
            }
            if (!this.business.id) {
              businesses
                .add(this.business)
                .then(doc => {
                  this.businessList.push({
                    id: doc.id,
                    name: this.business.name,
                    code: this.business.code
                  });
                  businesses.doc(doc.id).update({ id: doc.id });
                  this.setAppAlert({
                    visible: true,
                    text: "The business has been created",
                    color: "success"
                  });
                  this.clearBusiness();
                })
                .catch(error => {
                  this.setAppAlert({
                    visible: true,
                    text: error.message,
                    color: "error"
                  });
                });
            } else {
              businesses
                .doc(this.business.id)
                .update(this.business)
                .then(() => {
                  let id = this.business.id;
                  let businessIndex = this.businessList.findIndex(function(
                    element
                  ) {
                    return element.id === id;
                  });
                  if (
                    this.businessList[businessIndex].name !== this.business.name
                  ) {
                    this.businessList[businessIndex].name = this.business.name;
                  }
                  this.setAppAlert({
                    visible: true,
                    text: "The business has been updated",
                    color: "success"
                  });
                  this.clearBusiness();
                })
                .catch(error => {
                  this.setAppAlert({
                    visible: true,
                    text: error.message,
                    color: "error"
                  });
                });
            }
            return;
          }
        } else {
          this.setAppAlert({
            visible: true,
            text: "Some required fields are incomplete or invalid",
            color: "error"
          });
        }
      });
    },
    clearBusiness: function() {
      this.business.id = undefined;
      this.contact.valid = true;
      this.hideModal();
    }
  }
};
</script>

<style>
</style>
